import { DownloadContext, type DownloadContextValue } from "./DownloadContext.tsx"

export const DownloadProvider = ({ children, download, requestDownload, user }: DownloadProvider.Props) => {
  return (
    <DownloadContext.Provider
      value={{
        download,
        requestDownload,
        user
      }}
    >
      {children}
    </DownloadContext.Provider>
  )
}

export namespace DownloadProvider {
  export type Props = {
    children: React.ReactNode
  } & DownloadContextValue
}
